// extracted by mini-css-extract-plugin
export default {"row":"PurchaseIncentives_row__m6Blo","card":"PurchaseIncentives_card__dtGYY"};